import styled from 'styled-components';

import {
  DimensionStyling,
  DimensionStylingProps,
  MarginStyling,
  MarginStylingProps,
  PaddingStyling,
  PaddingStylingProps,
} from '../../styling';

export interface FlexItemProps {
  flex?: number;
  padding?: PaddingStylingProps;
  dimensions?: DimensionStylingProps;
  margin?: MarginStylingProps;
}

export const FlexItem = styled.div<FlexItemProps>`
  box-sizing: border-box;
  flex: ${({ flex }) => flex};

  ${({ padding }) => PaddingStyling(padding ?? {})};
  ${({ dimensions }) => DimensionStyling({ ...dimensions })};
  ${({ margin }) => MarginStyling({ ...margin })};
`;
